import { makeStyles, shorthands } from "@fluentui/react-components";

import { themeTokens } from "Core/Theme";

export const useM365PulseInfoRowStyles = makeStyles({
    root: {
        marginTop: "2px",
        marginBottom: "2px",
        display: "flex",
        alignItems: "top"
    },
    vertical: {
        flexDirection: "column"
    },
    infoItemFieldName: {
        flex: "0 0 auto",
        maxWidth: "150px",
        display: "block",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        ...shorthands.overflow("hidden"),
        marginRight: "5px"
    },
    infoItemContent: {
        fontWeight: themeTokens.fontWeightRegular
    },
    boldText: {
        fontWeight: themeTokens.fontWeightMedium
    },
    tooltip: {
        display: "inline-block",
        position: "relative",
        bottom: "5px"
    }
});
